import { useBoundStore } from "useStore";
import FilterChip from "./FilterChip";

export default function SearchFilterChip() {
  const search = useBoundStore((state) => state.campaignManagerSearch);
  const setSearch = useBoundStore((state) => state.setCampaignManagerSearch);

  if (!Array.isArray(search) || search.length === 0) return null;

  const handleDelete = (valueToRemove) => {
    setSearch(search.filter((item) => item.value !== valueToRemove));
  };

  return search.map((item) => (
    <FilterChip
      key={`${item.type}-${item.value}`}
      filterName={item.type}
      title={item.label || item.value}
      onDelete={() => handleDelete(item.value)}
    />
  ));
}
